module.exports = __webpack_public_path__ + "img/step1.b4b4d09d.svg";